import { render } from "./promotion.vue?vue&type=template&id=fe1bc36c&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"

import "./promotion.vue?vue&type=style&index=0&id=fe1bc36c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1bc36c"]])

export default __exports__